module.exports = __webpack_public_path__ + "static/media/image-uploader-placeholder_250x250.65d088bd.jpg";